type Permission = {
  action: '*' | string | string[] | undefined;
  resource: string;
};
type Params = {
  permissions: Permission[];
  action?: '*' | string;
  resource: string;
};

export const canAccessWithPermissions = ({
  permissions,
  action,
  resource,
}: Params): boolean => {
  if (!Array.isArray(permissions)) return false;

  /*
   * Loop permissions to support this format:
   * [
   *  {resource: "A", action: ["B", "C"]},
   *  {resource: "A", action: ["D"]},
   * ]
   */
  for (const p of permissions) {
    if (
      (p.resource === resource || p.resource === '*') &&
      hasAction(p.action, action)
    ) {
      return true;
    }
  }

  return false;
};

const hasAction = (
  permissionAction: Permission['action'],
  action: string | undefined
): boolean => {
  if (permissionAction === '*') {
    return true;
  }

  /*
   * Support action as string
   * Ex:
   *  { action: 'list' }
   */
  if (permissionAction === action) {
    return true;
  }

  /*
   * Support action as array
   * Ex:
   *  { action: ['list', 'show'] }
   */
  if (
    action &&
    Array.isArray(permissionAction) &&
    permissionAction.includes(action)
  ) {
    return true;
  }

  return false;
};
